/**
 * @file step
 * @author zhaomiaoyuan
 */
import React from 'react';
import {withRouter} from 'react-router';
import PropTypes from 'prop-types';
import InputFormItem from '../../components/InputFormItem/index.tsx';

import {Button} from 'antd';
import {recordProxy} from '../../util';
import './appeal.less';
const Step1 = (props) => {
    const {
        updateAppeal,
        appealData,
        // fetchAppealSearch,
        searchFn
    } = props;
    async function nextClick() {
        const recordType = window.location.pathname.indexOf('/occupy') > -1
            ? 'report-number_nextStep' : 'report-mark_nextStep';
        recordProxy(recordType, 'click', appealData.phone);
        if (!appealData.phone) {
            updateAppeal({
                phoneErr: '不能为空'
            });
            return;
        }
        searchFn(appealData);
    }
    // const getPhoneName = data => {
    //     if (!data) {
    //         return '';
    //     }
    //     const dataInfo = data?.list[0];
    //     let phoneName = '';
    //     switch(data.mode) {
    //         case 'customer':
    //             phoneName = dataInfo.key || dataInfo.title;
    //             break;
    //         case 'reports':
    //             phoneName = dataInfo.tag;
    //             break;
    //         case 'poi':
    //             phoneName = dataInfo.name;
    //             break;
    //     }
    //     return phoneName;
    // };
    // const searchFn = () => {
    //     recordProxy('appeal', 'click', 'search');
    //     const fetchAppealSearchFn = (params) => fetchAppealSearch({
    //         ...params,
    //         search: appealData.phone
    //     }).then(data => {
    //         if (data.code === 200 && data.data.list.length > 0) {
    //             const phoneName = getPhoneName(data.data);
    //             updateAppeal({
    //                 phoneName,
    //                 phoneErr: '',
    //                 curStep: 2,
    //                 titleName: appealData.appealType === 2 ? data.data.company : '' // appealType:2, 占用申诉
    //             });
    //         } else if (data.code === 200 && data.data.list.length === 0) {
    //             updateAppeal({
    //                 phoneErr: '该号码暂无标记，无需申诉'
    //             });
    //         } else {
    //             updateAppeal({
    //                 phoneErr: data.message
    //             });
    //         }
    //     });
    //     bCat_2055_request(fetchAppealSearchFn);
    // };
    return (
        <div className="step-1">
            <InputFormItem
                placeholder={appealData.appealType === 2 ? '请输入被占用的号码' : '请输入要取消标记的号码'}
                type="phone"
                data={appealData}
                updateData={updateAppeal}
                isMsgRequired={true}
            />
            <Button type="primary"
                className="btn-step1"
                onClick={nextClick}>下一步</Button>
        </div>
    );
};

Step1.propTypes = {
    searchFn: PropTypes.func,
    updateAppeal: PropTypes.func,
    appealData: PropTypes.object,
    fetchAppealSearch: PropTypes.func
};

export default withRouter(Step1);
